<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Stock-In Report</h4>
      </el-col>
      <el-col :sm="12">
        <div class="text-right">
          <!-- <el-select
            v-model="pager.batch_id"
            placeholder="Select batch information here"
            @change="fetch"
            clearable
            filterable
          >
            <el-option
              v-for="item in batches"
              :key="item.id"
              :label="item.batch_no"
              :value="item.id"
            ></el-option>
          </el-select> -->
          <el-button type="primary" size="small" @click="dialogView = true">
            Filter <span class="el-icon-search"></span>
          </el-button>
          <el-button class="ml-1" type="primary" size="small" @click="download"
            >Download Report</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-dialog ref="dialog" :visible.sync="dialogView" title="Report Filter">
      <el-form label-position="left" label-width="120px">
        <el-form-item label="Batch No.">
          <el-select
            v-model="pager.batch_id"
            placeholder="Select batch information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in batches"
              :key="item.id"
              :label="item.batch_no"
              :value="item.batch_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Supplier">
          <el-select
            v-model="pager.supplier_id"
            placeholder="Select supplier information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in suppliers"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Part">
          <el-select
            v-model="pager.part_id"
            placeholder="Select part information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in parts"
              :key="item.id"
              :label="item.part_no"
              :value="item.part_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date Range">
          <el-date-picker
            v-model="pager.date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="fetch(1)">Search</el-button>
      </el-form>
    </el-dialog>
    <el-table :data="list.data">
      <el-table-column label="Batch No." prop="batch_no"></el-table-column>
      <el-table-column label="Part No." prop="part_no"></el-table-column>
      <el-table-column label="Description" prop="description"></el-table-column>
      <el-table-column label="Supplier" prop="supplier"></el-table-column>
      <el-table-column label="Quantity" prop="quantity">
        <template slot-scope="scope">{{
          scope.row.quantity | number("0,0")
        }}</template>
      </el-table-column>
      <el-table-column
        label="Date Recevied"
        prop="date_received"
      ></el-table-column>
      <el-table-column label="Final Price (AED)" prop="final_price_aed">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_aed | currency("AED ") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Final Price (USD)" prop="final_price_usd">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_usd | currency("$ ") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-row :gutters="15" type="flex" align="middle">
      <el-col :sm="12">
        <el-pagination
          v-show="!isLoading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
      <el-col :sm="12" class="text-right">
        <!-- <a v-show="pager.supplier_id" :href="baseUrl"></a> -->
        <el-button type="primary" size="small" @click="download"
          >Download Report</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from "@/api";
import moment from "moment";
import Part from "@/models/Part";
import Supplier from "@/models/Supplier";
export default {
  name: "StockinReport",
  data() {
    return {
      isLoading: false,
      list: { data: [], paging: {} },
      pager: {
        limit: 25,
        batch_id: "",
        supplier_id: "",
        part_id: "",
        date_range: ""
      },
      batches: [],
      suppliers: [],
      parts: [],
      dialogView: false
    };
  },
  computed: {
    report_url() {
      // var uri = `${api.baseUrl}api/v1/inventory/reports_stockin/?q=1&download=1`;
      // if (this.pager.batch_id) return `${uri}&batch_id=${this.pager.batch_id}`;
      var uri = `api/v1/inventory/reports_stockin/?q=1&download=1&batch_no=${this.pager.batch_id}&supplier=${this.pager.supplier_id}&part_name=${this.pager.part_id}`;
      if (this.pager.date_range && this.pager.date_range.length > 1) {
        let date_from = moment(this.pager.date_range[0]);
        let date_to = moment(this.pager.date_range[1]);
        uri = `${uri}&date_from=${date_from.format(
          "YYYY-MM-DD"
        )}&date_to=${date_to.format("YYYY-MM-DD")}`;
      }
      return uri;
    },
    data_url() {
      // var uri = `api/v1/inventory/reports_stockin/?batch_no=${this.pager.batch_id}&supplier=${this.pager.supplier_id}&part_name=${this.pager.part_id}`;
      // if (this.pager.date_range && this.pager.date_range.length > 1) {
      //   let date_from = moment(this.pager.date_range[0]);
      //   let date_to = moment(this.pager.date_range[1]);
      //   uri = `${uri}&date_from=${date_from.format(
      //     "YYYY-MM-DD"
      //   )}&date_to=${date_to.format("YYYY-MM-DD")}`;
      // }
      // if (this.pager.batch_id) return `${uri}?batch_id=${this.pager.batch_id}`;
      return `api/v1/inventory/reports_stockin/`;
    }
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      let params = {
        page: page ? page : this.pager.page,
        limit: this.pager.limit,
        batch_no: this.pager.batch_id,
        supplier: this.pager.supplier_id,
        part_name: this.pager.part_id
      };
      api.get(this.data_url, params).then(resp => {
        if (resp && resp.status == 200) {
          this.isLoading = false;
          this.list = resp.data;
        }
      });
      this.dialogView = false;
    },
    download() {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `Stockin Report ${d}`,
        ext: ".csv"
      };
      this.isLoading = true;
      api.download(this.report_url, reportInfo).then(() => {
        this.isLoading = false;
      });
    }
  },
  mounted() {
    // this.fetch();
    api.get(`api/v1/inventory/batches/`).then(resp => {
      if (resp && resp.status == 200) {
        this.batches = resp.data.data;
      }
    });
    Part.getGlossary().then(list => {
      this.parts = list;
    });
    Supplier.getGlossary().then(list => {
      this.suppliers = list;
    });
  }
};
</script>
